import SwimlaneTiles from './SwimlaneTiles';

export default SwimlaneTiles;
